import React, { Component, useEffect, useState, useRef } from "react";
import PageSizeOptions from "../../PageSizeOptions";
import Pagination from "../../../comman/pagination";
import { paginate, calculateIndex } from "../../../utlis/paginate";
import SendEmail from "./SendEmail";
import { getFormatedNumber } from "../../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import {
  getFilterAllUsers,
  getRegisteredUsers,
  loadRegisteredUsers,
  loadRegisteredUsersByFilter,
  loadAllEmailHistory,
  getAllEmailHistory,
  getSentEmailStatus,
  getDeleteEmailStatus,
  SendEmailMessage,
  DeleteEmailMessage
} from "../../../app/store/users";
import { setCurrentPageTitle, setCurrentRoute } from "../../../app/store/layoutUI";
import MailHistory from "./MailHistory";
import { json, useParams } from "react-router-dom";
import AllCountries from "../../../services/allCountries";
import allCountryStates from "../../../services/allCountryStates";
import geoService from "../../../services/geoService";
import file from "file-saver";
import Moment from "react-moment";
import useDocDownload from "../../../app/hooks/useDocDownload";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";

const UsersEmail = (props) => {

  const { type, typeName } = props;

  const param = useParams();
  let msgType = param?.type;

  const route = [{ url: "", name: "Communications" }];

  const [candidates, setCandidates] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState([]);
  const [selectedPerformers, setSelectedPerformers] = useState([]);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [dataType, setDataType] = useState("");

  const [selectedObj, setSelectedObj] = useState(null);
  const [showHide, setShowHide] = useState(false);
  const [showHideMailHistory, setShowHideMailHistory] = useState(false);
  const [mailHistoryViewType, setMailHistoryViewType] = useState("all");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [userType, setUserType] = useState(type);
  const [totalCount, setTotalCount] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [viewType, setViewType] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);

  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedPerformer, setSelectedPerformer] = useState(null);
  const [selectedPerformerId, setSelectedPerformerId] = useState(0);
  const [expandedSentBodies, setExpandedSentBodies] = useState({});
  const [expandedDraftBodies, setExpandedDraftBodies] = useState({});

  const registeredUsersSelector = useSelector(getRegisteredUsers);
  const filterAllUsersSelector = useSelector(getFilterAllUsers);
  const allEmailHistorySelector = useSelector(getAllEmailHistory);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const deleteEmailStatusSelector = useSelector(getDeleteEmailStatus);

  const [handleDownloadFile] = useDocDownload();
  const [sendEmailShowHide, setSendEmailShowHide] = useState(false);
  const [selectedMailObj, setSelectedMailObj] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isInitial = useRef(true);
  const isInitialFilter = useRef(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedPerformerId) {
      dispatch(loadAllEmailHistory(selectedPerformerId));
    }
  }, [selectedPerformerId]);

  useEffect(() => {
    if (sentEmailStatusSelector) {
      getAlert("", "Draft Mail Sent Successfully", "success");
      if (selectedPerformerId) dispatch(loadAllEmailHistory(selectedPerformerId));
      handleRefreshData();
    }
  }, [sentEmailStatusSelector]);

  useEffect(() => {
    if (deleteEmailStatusSelector) {
      getAlert("", "Draft Mail Deleted Successfully", "success");
      if (selectedPerformerId) dispatch(loadAllEmailHistory(selectedPerformerId));
      handleRefreshData();
    }
  }, [deleteEmailStatusSelector]);

  const handleResetSelection = () => {
    setSelectedPerformerId(0);
    setSelectedPerformer(null);
    setSelectedEmail([]);
    setSelectedPerformers([]);
    setExpandedSentBodies({});
    setExpandedDraftBodies({});
  };

  const handleSelectPerformer = (item) => {
    const isSelected = selectedEmail.some(x => x.key === item.performerid);
    if (isSelected) {
      const newEmails = selectedEmail.filter(x => x.key !== item.performerid);
      setSelectedEmail(newEmails);
      
      const newPerformers = selectedPerformers.filter(x => x.performerid !== item.performerid);
      setSelectedPerformers(newPerformers);

      if (newEmails.length === 0) {
        setSelectedPerformerId(0);
        setSelectedPerformer(null);
      } else {
        const lastPerformer = newPerformers[newPerformers.length - 1];
        if (lastPerformer) {
          setSelectedPerformerId(lastPerformer.performerid);
          setSelectedPerformer(lastPerformer);
        }
      }
    } else {
      setSelectedEmail([...selectedEmail, { key: item.performerid, value: item.performeremail }]);
      setSelectedPerformers([...selectedPerformers, item]);
      setSelectedPerformerId(item.performerid);
      setSelectedPerformer(item);
    }
  };

  const getDisplayName = (performer) =>
    [performer?.performername, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };

  const handleTabSelect = (key) => {
    setSelectedKey(key);
  };

  const handleSendEmail = async (item) => {
    const result = await getConfirmAlert("Draft Email", "Are you sure you want to Send this Draft mail?", "warning");
    if (result.isConfirmed)
      dispatch(SendEmailMessage(item.id));
  };

  const handleDeleteEmail = async (item) => {
    const result = await getConfirmAlert("Draft Email", "Are you sure you want to Delete this Draft mail?", "warning");
    if (result.isConfirmed)
      dispatch(DeleteEmailMessage(item.id));
  };

  const handleSendEmailShowHide = (item) => {
    setSendEmailShowHide(!sendEmailShowHide);
    setSelectedMailObj(item);
  };

  const handleUpdateModalShowHide = () => {
    setSendEmailShowHide(false);
    setSelectedMailObj(null);
    if (selectedPerformerId) {
      dispatch(loadAllEmailHistory(selectedPerformerId));
    }
    handleRefreshData();
  };

  useEffect(() => {
    dispatch(setCurrentPageTitle(typeName));
    dispatch(setCurrentRoute(route));
  }, [])

  useEffect(() => {
    setIsLoading(true);
    dispatch(loadRegisteredUsers(pageSize, currentPage, userType))
  }, []);

  useEffect(() => {
    const selectorList = registeredUsersSelector || [];
    if (isInitial.current && selectorList.length === 0) {
      isInitial.current = false;
      return;
    }
    isInitial.current = false;

    if (selectorList.length > 0) {
      setRowsCount(selectorList[0].totalApplicants);
      setCandidates(selectorList);
    } else {
      setCandidates([]);
      setRowsCount(0);
    }
    setIsLoading(false);
  }, [registeredUsersSelector]);

  useEffect(() => {
    const filterList = filterAllUsersSelector || [];
    if (isInitialFilter.current && filterList.length === 0) {
      isInitialFilter.current = false;
      return;
    }
    isInitialFilter.current = false;

    setPageSize(5);
    setCurrentPage(1);
    getPagedData(filterList, 1, 5);
    setIsLoading(false);
  }, [filterAllUsersSelector]);

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalApplicants);

    setCandidates(items);
  };

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    handleResetSelection();
    setIsLoading(true);
    if (dataType === "filter")
      handleFilter();
    else
      dispatch(loadRegisteredUsers(pageSize, page, userType))
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    handleResetSelection();
    setIsLoading(true);
    if (dataType === "filter")
      handleFilter();
    else
      dispatch(loadRegisteredUsers(currentTarget.value, currentPage, userType));
  };

  const handleModalShowHide = (obj, keepSelection = false) => {
    if (obj === "" || obj === "save" || obj === undefined) {
      setShowHide(false);
      setSelectedObj(null);
      setSelectedKey("home");
      if (obj === "save") {
        handleResetSelection();
        if (dataType === "filter")
          handleFilter();
        else
          dispatch(loadRegisteredUsers(pageSize, currentPage, userType));

        setSelectedEmail([]);
        setSelectedPerformers([]);
      }
    }
    else {
      if (!keepSelection) {
        setSelectedEmail([{ key: obj.performerid, value: obj.performeremail }]);
        setSelectedPerformers([obj]);
        setSelectedPerformer(obj);
        setSelectedPerformerId(obj.performerid);
      }
      setSelectedKey("compose");
    }
  };


  const handleShowHideMailHistory = (obj, type) => {
    if (!obj) {
      setShowHideMailHistory(false);
      return;
    }
    setSelectedPerformer(obj);
    setSelectedPerformerId(obj.performerid);
    setSelectedEmail([{ key: obj.performerid, value: obj.performeremail }]);
    setSelectedPerformers([obj]);
    setShowHideMailHistory(false);
    setSelectedKey(type === "draft" ? "draft" : "sent");
  };


  const handleFilter = async () => {
    setIsFiltering(true);
    setDataType("filter");
    handleResetSelection();
    setSelectedKey("home");
    setIsLoading(true);
    const frmBody = new FormData();
    frmBody.append("id", userId);
    frmBody.append("name", userName);
    frmBody.append("email", userEmail);
    frmBody.append("type", userType);
    dispatch(loadRegisteredUsersByFilter(frmBody));
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = async () => {
    setDataType("");
    setUserId("");
    setUserName("");
    setUserEmail("");
    setCurrentPage(1);
    setPageSize(5);
    handleResetSelection();
    setIsLoading(true);
    dispatch(loadRegisteredUsers(5, 1, userType));
    setIsFiltering(false);
  };

  const handleRefreshData = () => {
    if (dataType === "filter")
      getPagedData(filterAllUsersSelector, currentPage, pageSize);
    else
      dispatch(loadRegisteredUsers(pageSize, currentPage, userType));
  };

  const handleRefresh = () => {
    if (dataType === "filter") handleFilter();
    else {
      handleResetSelection();
      setIsLoading(true);
      dispatch(loadRegisteredUsers(pageSize, currentPage, userType));
    }
  };

  const handleSaveFile = (data, name) => {
    const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
    file.saveAs(blob, name + ".json");
  };

  const loadAllCountryJs = async () => {
    console.log(AllCountries);
    const firstFiftyCountries = AllCountries.slice(200, 250);
    console.log(firstFiftyCountries);
    const countryStates = [];
    var result = await Promise.all(
      firstFiftyCountries.map(async (x) => {
        const st = await geoService.getGeoData(x.geonameId);
        //console.log(st);
        st.map(s => {
          const stObj = { ...s, countryGeonameId: x.geonameId };
          //console.log(stObj);
          countryStates.push(stObj);
        })
        //handleSaveFile(JSON.stringify(countryStates), x.countryName?.replace(/\s+/g, ''));
        //return countryStates;
        return x;
      })
    )

    console.log(result);
    console.log(countryStates);
    handleSaveFile(JSON.stringify(countryStates), "ctstates200_250");

  }


  return (
    <React.Fragment>
      <style>{`
        .wf-main-card,
        .wf-main-card input,
        .wf-main-card select,
        .wf-main-card button,
        .wf-main-card textarea,
        .wf-table-scroll th,
        .wf-table-scroll td {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 0;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: #ffffff !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: transparent !important;
          border: 1px solid rgba(100, 116, 139, 0.18) !important;
          color: #1e293b !important;
          border-radius: 0 !important;
          padding: 5px 12px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.2px !important;
        }

        .wf-stats-chip i {
          font-size: 14px !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: 32px !important;
          height: auto !important;
          box-sizing: border-box !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }

        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .search-panel-collapse :not(i) {
          font-weight: inherit !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          padding: 12px 20px !important;
          border-top: 1px solid rgba(226, 232, 240, 0.7) !important;
          background: linear-gradient(90deg, #ffffff 0%, #f8fafc 100%) !important;
        }

        .wf-control-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.08em !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 12px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-icon.wf-input-icon-top {
          top: 14px !important;
          transform: none !important;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          padding: 9px 14px !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          font-weight: 400 !important;
        }

        .wf-filter-input-no-icon .wf-input {
          padding-left: 14px !important;
        }

        .users-email-page .search-panel-collapse .wf-input-wrap > input.form-control.wf-input {
          padding-left: 14px !important;
          padding-inline-start: 14px !important;
          text-indent: 0 !important;
          text-align: left !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #ffffff !important;
        }

        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          min-height: 32px !important;
          height: auto !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: none !important;
        }

        .btn-action-search i {
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          font-weight: 500 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }

        .btn-action-search:disabled,
        .btn-action-search[disabled],
        .btn-action-search.btn-primary-search:disabled {
          background: #dbe2ea !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          opacity: 0.85 !important;
          transform: none !important;
          box-shadow: none !important;
        }

        .btn-action-search.btn-danger-search {
          background: rgba(239, 68, 68, 0.06) !important;
          color: #dc2626 !important;
          border: 1px solid rgba(239, 68, 68, 0.18) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: rgba(239, 68, 68, 0.12) !important;
          color: #b91c1c !important;
          border-color: rgba(239, 68, 68, 0.28) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
        }

        .wf-name-avatar {
          width: 34px;
          height: 34px;
          border-radius: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          color: #1e293b !important;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .wf-name-avatar.stack-avatar {
          background: #f5f5f5 !important;
          color: #1e293b !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: none !important;
          transition: transform 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .wf-name-avatar.stack-avatar:hover {
          transform: translateY(-2px) scale(1.05) !important;
          z-index: 15 !important;
        }
        .wf-name-avatar.stack-avatar.stack-more {
          background: #f5f5f5 !important;
          color: #1e293b !important;
          border: 1px solid #d4d4d4 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
        }

        /* Tabs styling */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #e5e5e5;
          margin-bottom: 0;
          padding: 8px 0 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          border-radius: 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 14px;
          color: currentColor;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #0f172a;
          background: #f5f5f5;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff;
          font-weight: 500;
          background: #171717;
        }

        .wf-tab-btn.active i {
          color: #ffffff;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #171717;
          border-radius: 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0);
        }

        .wf-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 0;
          font-size: 12px;
          font-weight: 500;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
          line-height: 1;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff;
          color: #1e293b;
          border-color: #ffffff;
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
        }

          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: none !important;
        }

        .btn-action-search i {
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          font-weight: 500 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }

        .btn-action-search:disabled,
        .btn-action-search[disabled],
        .btn-action-search.btn-primary-search:disabled {
          background: #dbe2ea !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          opacity: 0.85 !important;
          transform: none !important;
          box-shadow: none !important;
        }

        .btn-action-search.btn-danger-search {
          background: rgba(239, 68, 68, 0.06) !important;
          color: #dc2626 !important;
          border: 1px solid rgba(239, 68, 68, 0.18) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: rgba(239, 68, 68, 0.12) !important;
          color: #b91c1c !important;
          border-color: rgba(239, 68, 68, 0.28) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
        }

        .wf-name-avatar {
          width: 34px;
          height: 34px;
          border-radius: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          color: #1e293b !important;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .wf-name-avatar.stack-avatar {
          background: #f5f5f5 !important;
          color: #1e293b !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: none !important;
          transition: transform 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .wf-name-avatar.stack-avatar:hover {
          transform: translateY(-2px) scale(1.05) !important;
          z-index: 15 !important;
        }
        .wf-name-avatar.stack-avatar.stack-more {
          background: #f5f5f5 !important;
          color: #1e293b !important;
          border: 1px solid #d4d4d4 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
        }

        /* Tabs styling */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #e5e5e5;
          margin-bottom: 0;
          padding: 8px 0 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          border-radius: 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 14px;
          color: currentColor;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #0f172a;
          background: #f5f5f5;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff;
          font-weight: 500;
          background: #171717;
        }

        .wf-tab-btn.active i {
          color: #ffffff;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #171717;
          border-radius: 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0);
        }

        .wf-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 0;
          font-size: 12px;
          font-weight: 500;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
          line-height: 1;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff;
          color: #1e293b;
          border-color: #ffffff;
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
        }

        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        /* Assign card / Selected User card */
        .wf-assign-card {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          padding: 12px 18px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 14px !important;
          animation: assignFadeIn 0.3s ease both !important;
        }

        @keyframes assignFadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .wf-assign-info {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
        }

        .wf-assign-avatar {
          width: 40px !important;
          height: 40px !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #0f172a !important;
          font-weight: 700 !important;
          font-size: 14px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
        }

        .wf-avatar-stack {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-name-avatar.stack-avatar {
          width: 36px !important;
          height: 36px !important;
          border: 1px solid #cbd5e1 !important;
          background: #ffffff !important;
          color: #0f172a !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 0 !important;
          margin-left: 0 !important;
          box-shadow: none !important;
        }

        .wf-name-avatar.stack-more {
          width: 36px !important;
          height: 36px !important;
          background: #f1f5f9 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 0 !important;
        }

        .wf-assign-meta {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-assign-meta strong {
          color: #0f172a !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          line-height: 1.3 !important;
        }

        .wf-assign-meta span {
          color: #64748b !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
        }

        .wf-assign-actions {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
          margin-left: auto !important;
        }

        .wf-assign-actions .btn-danger-search {
          background: #ffffff !important;
          color: #ef4444 !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 6px 10px !important;
        }
        .wf-assign-actions .btn-danger-search:hover {
          background: #fef2f2 !important;
          border-color: #fca5a5 !important;
          color: #dc2626 !important;
        }

        /* Modern Table Style (Matched 100% with WorkflowUser) */
        .wf-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 2px !important;
        }

        .wf-table-scroll {
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background-color: #ffffff;
        }

        .wf-table-scroll::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-table-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 0;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 0;
          border: 2px solid #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
        }

        .wf-table-row:hover {
          background: #f8fafc !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-row:hover td {
          color: #000000 !important;
        }

        .wf-table-row:active {
          transform: scaleY(0.98) !important;
        }

        .wf-table-row.selected-row {
          background: #f1f5f9 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-row.selected-row:hover {
          background: #e2e8f0 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-row.selected-row td {
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        .wf-id-cell {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          min-width: 64px;
          padding: 4px 8px;
          border-radius: 0;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          font-size: 12px;
          font-weight: 500;
          color: #64748b;
        }

        .wf-id-cell.is-selected {
          background: #f5f5f5;
          border-color: #d4d4d4;
          color: #1e293b;
        }

        .wf-table td {
          padding: 13px 16px !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: middle !important;
        }

        /* Custom Checkbox Styles */
        .wf-checkbox-wrapper {
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
        }

        .wf-custom-checkbox {
          width: 18px;
          height: 18px;
          border-radius: 0;
          border: 2px solid #cbd5e1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          background: #ffffff;
          flex-shrink: 0;
        }

        .wf-table-row:hover .wf-custom-checkbox {
          border-color: #94a3b8;
        }

        .wf-custom-checkbox.checked {
          background: #2563eb;
          border-color: #2563eb;
          color: #ffffff;
        }

        .wf-custom-checkbox.checked i {
          transform: scale(1);
          opacity: 1;
        }

        .wf-custom-checkbox i {
          font-size: 10px;
          color: #ffffff;
          transform: scale(0.7);
          opacity: 0;
          transition: all 0.15s cubic-bezier(0.12, 0.4, 0.29, 1.46);
        }

        /* Avatar styles */
        .wf-name-cell { display: flex; align-items: center; gap: 10px; min-width: 190px; }
        .wf-name-avatar {
          width: 34px;
          height: 34px;
          border-radius: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5;
          border: 1px solid #d4d4d4;
          color: #1e293b;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .wf-avatar-stack {
          display: flex;
          align-items: center;
        }
        .wf-name-avatar.stack-avatar {
          background: #f5f5f5 !important;
          color: #1e293b !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: none !important;
          transition: transform 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .wf-name-avatar.stack-avatar:hover {
          transform: translateY(-2px) scale(1.05) !important;
          z-index: 15 !important;
        }
        .wf-name-avatar.stack-avatar.stack-more {
          background: #f1f5f9 !important;
          color: #64748b !important;
          border: 1px solid #d4d4d4 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
        }
        .wf-name-meta { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .wf-name-main { font-weight: 500; color: #1e293b; font-size: 14px; }

        .wf-data-line {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: #1e293b;
          font-size: 14px;
          font-weight: 400;
          white-space: nowrap;
        }
        .wf-data-line i {
          color: #94a3b8;
          font-size: 14px;
          transition: color 0.2s ease;
        }
        .wf-data-line i.fa-envelope-o, 
        .wf-assign-meta i.fa-envelope { color: #3b82f6 !important; }
        
        .wf-data-line i.fa-phone, 
        .wf-assign-meta i.fa-phone { color: #10b981 !important; }

        .wf-data-line i.fa-paper-plane { color: #0d9488 !important; }
        .wf-data-line i.fa-pencil-square-o { color: #7c3aed !important; }
        
        .wf-email-line {
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .wf-empty-value {
          color: #94a3b8;
          font-size: 12px;
          font-weight: 400;
        }

        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          color: #2563eb;
          margin-bottom: 4px;
        }

        .wf-compose-empty .wf-empty-icon {
          background: #f5f5f5;
          border: 1px solid #d4d4d4;
          color: #171717;
        }

        .wf-compose-empty .wf-empty-title {
          color: #171717;
        }

        .wf-compose-panel .awp-card {
          border: none;
          box-shadow: none;
          border-radius: 0;
          overflow: visible;
        }

        .wf-empty-title {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin: 0;
          width: 100%;
        }

        .wf-empty-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          width: 100%;
        }

        /* Re-used awp styles for tab headers */
        .awp-card {
          border: none;
          border-radius: 0;
          background: #ffffff;
          box-shadow: none;
          margin-top: 10px;
          overflow: visible;
        }

        .awp-form-header {
          display: flex; align-items: center; gap: 14px;
          padding: 16px 22px;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          position: relative; overflow: hidden;
          margin-bottom: 16px;
        }
        .awp-form-header-icon {
          width: 42px; height: 42px; border-radius: 0 !important;
          background: #ffffff !important; border: 1px solid #cbd5e1 !important;
          display: flex; align-items: center; justify-content: center;
          font-size: 14px; color: #1e293b; flex-shrink: 0;
        }
        .awp-form-header-title {
          color: #1e293b; font-size: 14px; font-weight: 500; margin: 0; line-height: 1.2;
        }
        .awp-form-header-sub {
          color: #64748b; font-size: 12px; margin-top: 3px; font-weight: 400; margin-bottom: 0;
        }
        .awp-form-header-badge {
          margin-left: auto;
          background: #f5f5f5; border: 1px solid #d4d4d4;
          border-radius: 0; padding: 4px 12px;
          color: #1e293b; font-size: 12px; font-weight: 500;
          display: flex; align-items: center; gap: 6px;
        }

        .wf-sent-panel .awp-card,
        .wf-draft-panel .awp-card,
        .wf-compose-panel .awp-card {
          margin-top: 0;
          border: none;
          box-shadow: none;
        }
        .wf-sent-panel .awp-form-body,
        .wf-draft-panel .awp-form-body,
        .wf-compose-panel .awp-form-body {
          padding: 0;
          background: #ffffff;
        }
        .wf-sent-panel .wf-table-scroll,
        .wf-draft-panel .wf-table-scroll {
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          background: #ffffff;
        }
        .wf-sent-panel .wf-table,
        .wf-draft-panel .wf-table {
          margin: 0 !important;
        }
        .wf-sent-panel .btn-action-search.btn-primary-search,
        .wf-draft-panel .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          font-weight: 500 !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.15) !important;
        }
        .wf-sent-panel .btn-action-search.btn-primary-search:hover,
        .wf-draft-panel .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }
        .wf-compose-panel .awp-form-header,
        .wf-sent-panel .awp-form-header,
        .wf-draft-panel .awp-form-header {
          gap: 14px;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          margin-bottom: 16px;
        }
        .wf-sent-panel .awp-form-header .btn-action-search,
        .wf-draft-panel .awp-form-header .btn-action-search {
          margin-left: auto;
        }
        .wf-draft-panel .btn-icon-delete {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 34px !important;
          height: 34px !important;
          min-height: 34px !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: rgba(239,68,68,0.06) !important;
          color: #dc2626 !important;
          border: 1px solid rgba(239,68,68,0.18) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
        }
        .wf-draft-panel .btn-icon-delete:hover {
          background: rgba(239,68,68,0.12) !important;
          color: #b91c1c !important;
          border-color: rgba(239,68,68,0.28) !important;
        }
        .wf-draft-panel .btn-icon-delete i {
          font-size: 13px;
        }
        .wf-sent-body-clamp {
          max-height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.4;
          color: #64748b;
          white-space: normal;
          word-break: break-word;
        }
        .wf-sent-body-expanded {
          max-height: none;
          overflow: visible;
          display: block;
          -webkit-line-clamp: unset;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          color: #1e293b;
          white-space: pre-wrap;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .wf-sent-body-wrap {
          max-width: 420px;
        }
        .wf-sent-show-more {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          margin-top: 6px;
          padding: 0;
          border: none;
          background: transparent;
          color: #1e293b;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          text-decoration: underline;
          text-underline-offset: 2px;
        }
        .wf-sent-show-more:hover {
          color: #0f172a;
        }
        .wf-sent-show-more:focus {
          outline: none;
        }
        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          line-height: 1 !important;
        }
        .badge-sent {
          background: rgba(16,185,129,0.08) !important;
          color: #047857 !important;
          border: 1px solid rgba(16,185,129,0.15) !important;
        }
        .badge-draft {
          background: #f5f5f5 !important;
          color: #525252 !important;
          border: 1px solid #d4d4d4 !important;
        }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 wf-main-card shadow-none users-email-page">
          <div className="wf-card-header-bar">
            {isLoading && <div className="wf-loading-bar" />}
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                {rowsCount} Total
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#collapseExample"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                disabled={isLoading}
                title={`Reload ${typeName}`}
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          <div className="px-3">
            <div className="collapse" id="collapseExample">
              <div className="search-panel-collapse">

                {/* Panel Header */}
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter {typeName}
                  </span>
                </div>

                {/* Filter Fields */}
                <div className="sp-body">
                  <div className="row">

                    {/* User ID */}
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="userId" className="wf-control-label">
                        ID
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userId"
                          id="userId"
                          className="form-control wf-input"
                          placeholder="e.g. 1042"
                          value={userId}
                          onChange={({ currentTarget }) => setUserId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* User Name */}
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="userName" className="wf-control-label">
                        Name
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userName"
                          id="userName"
                          className="form-control wf-input"
                          placeholder="Search name…"
                          value={userName}
                          onChange={({ currentTarget }) => setUserName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* User Email */}
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="userEmail" className="wf-control-label">
                        Email
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userEmail"
                          id="userEmail"
                          className="form-control wf-input"
                          placeholder="Search email…"
                          value={userEmail}
                          onChange={({ currentTarget }) => setUserEmail(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Action Footer */}
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter()}
                    disabled={isFiltering || (!userId.trim() && !userName.trim() && !userEmail.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">
            {/* Custom Tab Bar */}
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => handleTabSelect("home")}
              >
                <i className="fa fa-list-alt" />
                {typeName}
                <span className="wf-tab-badge">{candidates.length > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "compose" ? " active" : ""}`}
                onClick={() => handleTabSelect("compose")}
              >
                <i className="fa fa-envelope" />
                Compose
                {selectedPerformerId > 0 && selectedEmail.length > 0 && (
                  <span className="wf-tab-badge">{selectedEmail.length}</span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "sent" ? " active" : ""}`}
                onClick={() => handleTabSelect("sent")}
              >
                <i className="fa fa-paper-plane" />
                Sent
                {selectedPerformerId > 0 && (
                  <span className="wf-tab-badge">
                    {selectedPerformer?.allMail || 0}
                  </span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "draft" ? " active" : ""}`}
                onClick={() => handleTabSelect("draft")}
              >
                <i className="fa fa-pencil-square-o" />
                Drafts
                {selectedPerformerId > 0 && (
                  <span className="wf-tab-badge">
                    {selectedPerformer?.draftMail || 0}
                  </span>
                )}
              </button>
            </div>

            {/* Tab Panels */}
            {selectedKey === "home" && (
              <div className="wf-tab-panel">
                {/* Selected user context card */}
                {selectedPerformerId > 0 && selectedPerformer && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      {selectedPerformers.length > 1 ? (
                        <div className="wf-avatar-stack">
                          {selectedPerformers.slice(0, 3).map((perf, idx) => (
                            <span
                              key={perf.performerid}
                              className="wf-name-avatar stack-avatar"
                              style={{
                                zIndex: 10 - idx,
                                marginLeft: idx > 0 ? "-12px" : "0"
                              }}
                              title={`${perf.performername} ${perf.lastName}`}
                            >
                              {getInitials(perf)}
                            </span>
                          ))}
                          {selectedPerformers.length > 3 && (
                            <span
                              className="wf-name-avatar stack-avatar stack-more"
                              style={{
                                zIndex: 5,
                                marginLeft: "-12px"
                              }}
                            >
                              +{selectedPerformers.length - 3}
                            </span>
                          )}
                        </div>
                      ) : (
                        <div className="wf-assign-avatar">
                          {getInitials(selectedPerformer)}
                        </div>
                      )}
                      <div className="wf-assign-meta">
                        {selectedPerformers.length > 1 ? (
                          <>
                            <strong>{selectedPerformers.length} Recipients Selected</strong>
                            <span>
                              Active Performer: {selectedPerformer.performername} {selectedPerformer.lastName} ({selectedPerformer.performeremail})
                            </span>
                          </>
                        ) : (
                          <>
                            <strong>
                              {selectedPerformer.performername} {selectedPerformer.lastName}
                            </strong>
                            <span>
                              {selectedPerformer.performeremail}
                              &nbsp;&bull;&nbsp;
                              {selectedPerformer.contactNo ? getFormatedNumber(selectedPerformer.contactNo) : "No Contact"}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      {selectedPerformers.length <= 1 && (
                        <>
                          <button
                            type="button"
                            className="btn-action-search"
                            onClick={() => handleTabSelect("sent")}
                          >
                            <i className="fa fa-paper-plane" /> Sent ({selectedPerformer.allMail || 0})
                          </button>
                          <button
                            type="button"
                            className="btn-action-search"
                            onClick={() => handleTabSelect("draft")}
                          >
                            <i className="fa fa-pencil-square-o" /> Drafts ({selectedPerformer.draftMail || 0})
                          </button>
                        </>
                      )}
                      <button
                        type="button"
                        className="btn-action-search"
                        onClick={() => handleModalShowHide(selectedPerformer, true)}
                      >
                        {selectedPerformers.length > 1 ? `Send Bulk ${msgType === "text" ? "Text" : "Email"} (${selectedPerformers.length})` : `Send ${msgType === "text" ? "Text" : "Email"}`}
                      </button>
                      <button
                        type="button"
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush table-striped wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th style={{ minWidth: "360px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          </tr>
                        ))
                      ) : candidates.length === 0 ? (
                        <tr>
                          <td colSpan={5} style={{ padding: 0 }}>
                            <div className="wf-empty-state" style={{ minHeight: "250px" }}>
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-list-alt"} />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Registered Users Found"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the search filters to find users."
                                  : `There are no registered ${typeName.toLowerCase()} found in the system.`}
                              </p>
                              {dataType === "filter" && (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" />
                                  Reset Filters
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        candidates.map((item) => (
                          <tr
                            key={item.performerid}
                            className={`wf-table-row ${selectedEmail.some(x => x.key === item.performerid) ? "selected-row" : ""}`}
                            onClick={() => handleSelectPerformer(item)}
                            title={selectedEmail.some(x => x.key === item.performerid) ? `Click to deselect: ${item.performername}` : `Click to select: ${item.performername}`}
                          >
                            <td>
                              <span style={{ fontSize: "14px", fontWeight: 400, color: "#1e293b" }}>
                                #{item.performerid}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(item)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main text-uppercase" style={{ fontSize: "14px", fontWeight: 500, color: "#1e293b" }}>
                                    {item.performername}&nbsp;{item.lastName}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span style={{ fontSize: "14px", fontWeight: 400, color: "#1e293b" }}>
                                {item.performeremail || "No Email"}
                              </span>
                            </td>
                            <td>
                              <span style={{ fontSize: "14px", fontWeight: 400, color: "#1e293b" }}>
                                {item.contactNo ? getFormatedNumber(item.contactNo) : "No Contact"}
                              </span>
                            </td>
                            <td onClick={(e) => e.stopPropagation()}>
                              <div style={{ display: "inline-flex", gap: "8px", alignItems: "center" }}>
                                <button
                                  type="button"
                                  className="btn-action-search"
                                  onClick={() => handleShowHideMailHistory(item, "all")}
                                  title="View Sent History"
                                >
                                  Sent ({item.allMail})
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search"
                                  onClick={() => handleShowHideMailHistory(item, "draft")}
                                  title="View Draft Messages"
                                >
                                  Drafts ({item.draftMail})
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search"
                                  onClick={() => handleModalShowHide(item)}
                                  title="Compose and Send Message"
                                >
                                  Send
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <div className="mt-3">
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedKey === "compose" && (
              <div className="wf-tab-panel pt-2 wf-compose-panel">
                {selectedPerformerId > 0 ? (
                  <SendEmail
                    showHide={true}
                    handleModalShowHide={handleModalShowHide}
                    selectedObj={selectedPerformer}
                    selectedEmail={selectedEmail}
                    viewType="add"
                    isInline={true}
                    msgType={`${userType}${" "}${msgType}`}
                  />
                ) : (
                  <div className="wf-empty-state wf-compose-empty">
                    <div className="wf-empty-icon">
                      <i className="fa fa-envelope" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">Select a user from the table to compose and send a message.</p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back
                    </button>
                  </div>
                )}
              </div>
            )}

            {selectedKey === "sent" && (
              <div className="wf-tab-panel pt-2 wf-sent-panel">
                {selectedPerformerId > 0 ? (
                  <>
                    <div className="awp-card">
                      <div className="awp-form-header">
                        <div className="awp-form-header-icon">
                          <i className="fa fa-paper-plane" />
                        </div>
                        <div className="awp-form-header-text">
                          <p className="awp-form-header-title">Sent History</p>
                          <p className="awp-form-header-sub">
                            Previously sent messages for this user
                          </p>
                        </div>
                        <button
                          type="button"
                          className="btn-action-search"
                          onClick={() => handleTabSelect("home")}
                        >
                          <i className="fa fa-arrow-left" /> Back
                        </button>
                      </div>

                      <div className="awp-form-body">
                        <div className="table-responsive wf-table-scroll">
                          <table className="table align-items-center table-flush wf-table">
                            <thead className="wf-thead">
                              <tr>
                                <th style={{ width: 70 }} aria-label="Serial number" />
                                <th style={{ width: 200 }}>Sent</th>
                                <th style={{ width: 240 }}>Subject</th>
                                <th>Body</th>
                                <th style={{ width: 220 }}>Attachments</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(allEmailHistorySelector || []).filter((x) => x.sendStatus === true).length === 0 ? (
                                <tr>
                                  <td colSpan={5} style={{ padding: 0 }}>
                                    <div className="wf-empty-state" style={{ minHeight: 220 }}>
                                      <div className="wf-empty-icon" style={{ background: "#171717", color: "#ffffff", borderColor: "#171717" }}>
                                        <i className="fa fa-paper-plane-o" />
                                      </div>
                                      <p className="wf-empty-title">No Sent Messages</p>
                                      <p className="wf-empty-desc" style={{ maxWidth: 400 }}>
                                        You haven&apos;t sent any messages to {selectedPerformer?.performername} yet.
                                      </p>
                                      <button
                                        type="button"
                                        className="btn-action-search btn-primary-search"
                                        onClick={() => handleTabSelect("compose")}
                                        style={{ marginTop: 4 }}
                                      >
                                        <i className="fa fa-envelope" /> Compose Message
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                (allEmailHistorySelector || [])
                                  .filter((x) => x.sendStatus === true)
                                  .map((item, idx) => {
                                    const bodyKey = item.id || idx;
                                    const bodyText = item.mailBody || "";
                                    const isExpanded = !!expandedSentBodies[bodyKey];
                                    const canExpand = bodyText.length > 90;
                                    return (
                                    <tr key={bodyKey} className="wf-table-row">
                                      <td>
                                        <span>#{idx + 1}</span>
                                      </td>
                                      <td>
                                        {item.sendDateTime || item.addedDateTime ? (
                                          <span className="wf-data-line">
                                            <Moment format="MMM Do YYYY, h:mm a">
                                              {item.sendDateTime || item.addedDateTime}
                                            </Moment>
                                          </span>
                                        ) : (
                                          <span className="wf-empty-value">—</span>
                                        )}
                                      </td>
                                      <td>
                                          <span
                                          className="text-truncate d-block"
                                          style={{ maxWidth: 220, fontWeight: 400, color: "#1e293b", fontSize: "14px" }}
                                          title={item.subject}
                                        >
                                          {item.subject || (
                                            <span className="wf-empty-value">No Subject</span>
                                          )}
                                        </span>
                                      </td>
                                      <td>
                                        <div className="wf-sent-body-wrap">
                                          {bodyText ? (
                                            <>
                                              <div
                                                className={isExpanded ? "wf-sent-body-expanded" : "wf-sent-body-clamp"}
                                              >
                                                {bodyText}
                                              </div>
                                              {canExpand && (
                                                <button
                                                  type="button"
                                                  className="wf-sent-show-more"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setExpandedSentBodies((prev) => ({
                                                      ...prev,
                                                      [bodyKey]: !prev[bodyKey],
                                                    }));
                                                  }}
                                                >
                                                  {isExpanded ? "Show less" : "Show more"}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <span className="wf-empty-value">Empty message</span>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        {item?.documents?.length > 0 ? (
                                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                            {item.documents.map((file, fIdx) => (
                                              <button
                                                key={fIdx}
                                                type="button"
                                                className="btn-action-search"
                                                style={{ padding: "7px 14px", fontSize: 14, fontWeight: 500, height: "auto", minHeight: "auto" }}
                                                title="Download Attachment"
                                                onClick={() => handleDownloadFile(file)}
                                              >
                                                <i className="fa fa-paperclip" style={{ fontSize: 14 }} />
                                                <span className="text-truncate" style={{ maxWidth: 100 }}>
                                                  {file.documentName}
                                                </span>
                                              </button>
                                            ))}
                                          </div>
                                        ) : (
                                          <span className="wf-empty-value">None</span>
                                        )}
                                      </td>
                                    </tr>
                                    );
                                  })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="wf-empty-state wf-compose-empty">
                    <div className="wf-empty-icon">
                      <i className="fa fa-paper-plane" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the table to view sent message history.
                    </p>
                    <button
                      type="button"
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back
                    </button>
                  </div>
                )}
              </div>
            )}

            {selectedKey === "draft" && (
              <div className="wf-tab-panel pt-2 wf-draft-panel">
                {selectedPerformerId > 0 ? (
                  <>
                    <div className="awp-card">
                      <div className="awp-form-header">
                        <div className="awp-form-header-icon">
                          <i className="fa fa-pencil-square-o" />
                        </div>
                        <div className="awp-form-header-text">
                          <p className="awp-form-header-title">Draft Messages</p>
                          <p className="awp-form-header-sub">
                            Unsent drafts for this user
                          </p>
                        </div>
                        <button
                          type="button"
                          className="btn-action-search"
                          onClick={() => handleTabSelect("home")}
                        >
                          <i className="fa fa-arrow-left" /> Back
                        </button>
                      </div>

                      <div className="awp-form-body">
                        <div className="table-responsive wf-table-scroll">
                          <table className="table align-items-center table-flush wf-table">
                            <thead className="wf-thead">
                              <tr>
                                <th style={{ width: 70 }} aria-label="Serial number" />
                                <th style={{ width: 200 }}>Created</th>
                                <th style={{ width: 220 }}>Subject</th>
                                <th>Body</th>
                                <th style={{ width: 200 }}>Attachments</th>
                                <th style={{ width: 240 }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(allEmailHistorySelector || []).filter((x) => x.sendStatus !== true).length === 0 ? (
                                <tr>
                                  <td colSpan={6} style={{ padding: 0 }}>
                                    <div className="wf-empty-state" style={{ minHeight: 220 }}>
                                      <div className="wf-empty-icon" style={{ background: "#171717", color: "#ffffff", borderColor: "#171717" }}>
                                        <i className="fa fa-pencil-square-o" />
                                      </div>
                                      <p className="wf-empty-title">No Draft Messages</p>
                                      <p className="wf-empty-desc" style={{ maxWidth: 400 }}>
                                        There are no saved drafts for {selectedPerformer?.performername}.
                                      </p>
                                      <button
                                        type="button"
                                        className="btn-action-search btn-primary-search"
                                        onClick={() => handleTabSelect("compose")}
                                        style={{ marginTop: 4 }}
                                      >
                                        <i className="fa fa-envelope" /> Compose Message
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                (allEmailHistorySelector || [])
                                  .filter((x) => x.sendStatus !== true)
                                  .map((item, idx) => {
                                    const bodyKey = item.id || idx;
                                    const bodyText = item.mailBody || "";
                                    const isExpanded = !!expandedDraftBodies[bodyKey];
                                    const canExpand = bodyText.length > 90;
                                    return (
                                      <tr key={bodyKey} className="wf-table-row">
                                        <td>
                                          <span>#{idx + 1}</span>
                                        </td>
                                        <td>
                                          {item.addedDateTime ? (
                                            <span className="wf-data-line">
                                              <Moment format="MMM Do YYYY, h:mm a">
                                                {item.addedDateTime}
                                              </Moment>
                                            </span>
                                          ) : (
                                            <span className="wf-empty-value">—</span>
                                          )}
                                        </td>
                                        <td>
                                          <span
                                            className="text-truncate d-block"
                                            style={{ maxWidth: 200, fontWeight: 400, color: "#1e293b", fontSize: "14px" }}
                                            title={item.subject}
                                          >
                                            {item.subject || (
                                              <span className="wf-empty-value">No Subject</span>
                                            )}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="wf-sent-body-wrap">
                                            {bodyText ? (
                                              <>
                                                <div
                                                  className={isExpanded ? "wf-sent-body-expanded" : "wf-sent-body-clamp"}
                                                >
                                                  {bodyText}
                                                </div>
                                                {canExpand && (
                                                  <button
                                                    type="button"
                                                    className="wf-sent-show-more"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setExpandedDraftBodies((prev) => ({
                                                        ...prev,
                                                        [bodyKey]: !prev[bodyKey],
                                                      }));
                                                    }}
                                                  >
                                                    {isExpanded ? "Show less" : "Show more"}
                                                  </button>
                                                )}
                                              </>
                                            ) : (
                                              <span className="wf-empty-value">Empty message</span>
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          {item?.documents?.length > 0 ? (
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                              {item.documents.map((file, fIdx) => (
                                                <button
                                                  key={fIdx}
                                                  type="button"
                                                  className="btn-action-search"
                                                  style={{ padding: "7px 14px", fontSize: 14, fontWeight: 500, height: "auto", minHeight: "auto" }}
                                                  title="Download Attachment"
                                                  onClick={() => handleDownloadFile(file)}
                                                >
                                                  <i className="fa fa-paperclip" style={{ fontSize: 14 }} />
                                                  <span className="text-truncate" style={{ maxWidth: 100 }}>
                                                    {file.documentName}
                                                  </span>
                                                </button>
                                              ))}
                                            </div>
                                          ) : (
                                            <span className="wf-empty-value">None</span>
                                          )}
                                        </td>
                                        <td onClick={(e) => e.stopPropagation()}>
                                          <div style={{ display: "inline-flex", gap: 6, flexWrap: "wrap" }}>
                                            <button
                                              type="button"
                                              className="btn-action-search"
                                              style={{ padding: "6px 10px", height: "auto", minHeight: "auto" }}
                                              onClick={() => handleSendEmail(item)}
                                              title="Send Draft"
                                            >
                                              Send
                                            </button>
                                            <button
                                              type="button"
                                              className="btn-action-search"
                                              style={{ padding: "6px 10px", height: "auto", minHeight: "auto" }}
                                              onClick={() => handleSendEmailShowHide(item)}
                                              title="Edit Draft"
                                            >
                                              Edit
                                            </button>
                                            <button
                                              type="button"
                                              className="btn-icon-delete"
                                              onClick={() => handleDeleteEmail(item)}
                                              title="Delete Draft"
                                            >
                                              <i className="fa fa-trash" aria-hidden="true" />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="wf-empty-state wf-compose-empty">
                    <div className="wf-empty-icon">
                      <i className="fa fa-pencil-square-o" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the table to view draft messages.
                    </p>
                    <button
                      type="button"
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {showHide && (
            <SendEmail
              showHide={showHide}
              handleModalShowHide={handleModalShowHide}
              selectedObj={selectedObj}
              selectedEmail={selectedEmail}
              viewType="add"
              msgType={`${userType}${" "}${msgType}`}
            />
          )}

          {showHideMailHistory && (
            <MailHistory
              showHideMailHistory={showHideMailHistory}
              handleShowHideMailHistory={handleShowHideMailHistory}
              selectedObj={selectedPerformer}
              handleRefreshData={handleRefreshData}
              viewType={mailHistoryViewType}
            />
          )}

          {sendEmailShowHide && (
            <SendEmail
              showHide={sendEmailShowHide}
              handleModalShowHide={handleSendEmailShowHide}
              handleUpdateModalShowHide={handleUpdateModalShowHide}
              selectedObj={selectedPerformer}
              selectedEmail={selectedEmail}
              selectedMailObj={selectedMailObj}
              viewType="edit"
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default UsersEmail;
